<template>
	<div class="con-list base-info">
		<van-field v-model="data.lastNameSrch" prop="lastNameSrch" required  label="姓" placeholder="请输入姓"
		@input="searchFirstNameSrch('1')" :disabled="isCheckId || isDetail" :rules="[{ required: true, message: '姓不能为空', trigger: 'onChange' }]"/>

		<van-field v-model="data.firstNameSrch"   prop="firstNameSrch" required  label="名" placeholder="请输入名"
			@input="searchFirstNameSrch" :disabled="isCheckId || isDetail" :rules="[{ required: true, message: '名不能为空', trigger: 'onChange' }]"/>

		<van-field v-model="data.lastNameAc" class="select" :is-link="!isDetail"  readonly :clickable="!isDetail" prop="lastNameAc" required  label="姓拼音" placeholder="请选择姓拼音"
			:disabled="isCheckId || isDetail" @click="selectValue(firstNameSrchList,'firstNameSrchList')" :rules="[{ required: true, message: '姓拼音不能为空', trigger: 'onChange' }]" />

		<van-field v-model="data.firstNameAc" class="select" :is-link="!isDetail"  readonly :clickable="!isDetail"  prop="firstNameAc" required name="名拼音" label="名拼音" placeholder="请选择名拼音"
		:disabled="isCheckId || isDetail" @click="selectValue(firstNameAcList,'firstNameAcList')" :rules="[{ required: true, message: '名拼音不能为空', trigger: 'onChange' }]" />

		<van-field v-model="data.fullName" prop="fullName" required  label="姓名拼音" placeholder="" disabled  :rules="[{ required: true, message: '姓名拼音不能为空', trigger: 'onChange' }]"/>

		<van-field readonly clickable v-if="!isDetail" class="select" is-link v-model="maritalStatusName" prop="maritalStatus" :disabled="isDetail" required label="婚姻状态"  placeholder="请选择婚姻状态"  @click="selectValue(maritalStatusList,'maritalStatusList')" :rules="[{ required: true, message: '婚姻状态不能为空', trigger: 'onChange' }]"/>
		<van-field readonly  required v-else disabled v-model="data.maritalStatusDescr"  label="婚姻状态"/>

		<van-field readonly clickable v-if="!isDetail" class="select" is-link v-model="countryName" prop="country" :disabled="isDetail || isCheckId" required label="国籍"  placeholder=""  @click="selectValue(nationIdList,'nationIdList')" :rules="[{ required: true, message: '国籍不能为空', trigger: 'onChange' }]"/>
		<van-field readonly  required v-else disabled v-model="data.countryDescr"  label="国籍"/>
		
		<van-field readonly clickable v-if="!isDetail" class="select" is-link v-model="nationalIdTypeName" prop="nationalIdType"  :disabled="isDetail" required  label="证件类型" placeholder="请选择证件类型"
		:rules="[{ required: true, message: '证件类型不能为空', trigger: 'onChange' }]"  @click="selectValue(nationalTypeList,'nationalTypeList')"  />
		<van-field readonly  v-else v-model="data.nationalIdTypeDescr" prop="nationalIdType" disabled required  label="证件类型"   />

		<van-field v-model.trim="data.nationalId" maxlength="20" :class="{'no-border-bottom':!isDetail}" prop="nationalId" :disabled="isDetail || isCheckId" required  label="证件号码" placeholder="请输入证件号码" :rules="[{ required: true, message: '证件号码不能为空', trigger: 'onChange' }]"/>
		<div class="yz" v-if="!isDetail">
			<span class="tip" v-if="!isDetail">提示：请验证身份证号与姓名是否匹配，如不匹配，需要重新验证，否则无法提交审批。</span>
			<van-button type="primary" size="small"  @click="checkIdCard">身份验证</van-button>
			
		</div>

		<van-field 
			v-if="!isDetail" 
			readonly 
			clickable 
			required 
			:disabled="isDetail || (data.nationalIdType === '1A' && data.nationalId.length === 18) || isCheckId" 
			:style="{ 'pointer-events': isDetail || (data.nationalIdType === '1A' && data.nationalId.length === 18) || isCheckId ? 'none' : 'auto' }"
			v-model="data.birthDate" 
			prop="birthDate" 
			label="出生日期" 
			placeholder="请选择日期"
			@click="showCalendar = true" 
			:rules="[{ required: true, message: '出生日期不能为空', trigger: 'onChange' }]"/>
		<van-field readonly  required v-else disabled v-model="data.birthDate"  label="出生日期"/>

		<van-field v-if="!isDetail" name="radio" required label="性别">
			<template #input>
				<van-radio-group v-model="data.sex" :disabled="sexDisablle || isCheckId" direction="horizontal">
					<van-radio name="M">男</van-radio>
					<van-radio name="F">女</van-radio>
				</van-radio-group>
			</template>
		</van-field>
		<van-field v-else disabled required v-model="data.sexDescr"  label="性别"/>

		<van-field v-model="data.phone" prop="phone" type="tel" v-if="!isDetail" required  label="手机号" placeholder="请输入手机号" :rules="[{ required: true, message: '手机号不能为空', trigger: 'onChange' }, { pattern: /^1[0-9]{10}$/, message: '手机号格式有误',trigger: 'onBlur' }]"/>
		<van-field v-model="data.entryPhone" type="tel" v-else :disabled="isDetail" label="手机号" placeholder="请输入手机号"/>

		<van-field v-if="!isDetail" readonly clickable is-link v-model="channelName" class="select"  prop="channel" required label="招聘渠道" placeholder="请选择招聘渠道" @click="selectValue(channelList,'channelList')" :rules="[{ required: true, message: '招聘渠道不能为空', trigger: 'onChange' }]" />
		<van-field v-else readonly  disabled required v-model="data.channelDescr"  label="招聘渠道"/>

		<van-field readonly clickable v-if="data.channel ==='3' && !isDetail" v-model="recomUserName" prop="recomUser" required label="推荐人" @click="selectInfo" placeholder="请输入推荐人搜索" :rules="[{ required: true, message: '推荐人不能为空', trigger: 'onChange' }]"/>
		<van-field readonly  v-if="data.channel ==='3' && isDetail" v-model="data.recomUserName" disabled prop="recomUser" required label="推荐人" />

		<van-field v-model="data.curResidentAddress" type="textarea" rows="1" autosize prop="curResidentAddress" style="padding-right:16px;" required label="现住址" :disabled="isDetail" placeholder="请输入现住址" :rules="[{ required: true, message: '现住址不能为空', trigger: 'onChange' }, { pattern: /^[\s\S]{10,400}$/, message: '请精确到门牌号，填写需要10个字以上',trigger: 'onBlur' }]" />

		<van-field readonly clickable v-if="!isDetail" class="select" is-link v-model="driverLicenseTypeName" prop="driverLicenseType" :disabled="isDetail" required label="驾驶执照类型"  placeholder="请选择驾照类型"  @click="selectValue(driverLicenseTypeList,'driverLicenseTypeList')" :rules="[{ required: true, message: '驾驶执照类型不能为空', trigger: 'onChange' }]"/>
		<van-field readonly  required v-else disabled v-model="data.driverLicenseTypeDescr"  label="驾驶执照类型"/>

		<van-field v-if="!isDetail && this.data.driverLicenseType!='10'" readonly clickable required :disabled="isDetail" v-model="data.driverLicenseEffectDate" prop="driverLicenseEffectDate" label="驾驶执照到期日" placeholder="请选择日期"
			@click="showDiverCalendar = true" :rules="[{ required: true, message: '驾驶执照到期日不能为空', trigger: 'onChange' }]"/>
		<van-field readonly  required v-if="isDetail && data.driverLicenseTypeDescr !== '无'" disabled v-model="data.driverLicenseEffectDate"  label="驾驶执照到期日"/>

		<van-field v-model="data.emergencyContactor" prop="emergencyContactor" required  label="紧急联系人姓名" placeholder="请输入紧急联系人姓名"
		 :disabled="isDetail" :rules="[{ required: true, message: '紧急联系人姓名不能为空', trigger: 'onChange' }]"/>

		<van-field v-model="data.emergencyContactorPhone" prop="emergencyContactorPhone" type="tel" :disabled="isDetail" required  label="紧急联系人电话" placeholder="请输入紧急联系人电话" :rules="[{ required: true, message: '紧急联系人电话不能为空', trigger: 'onChange' }, { pattern: /^1[0-9]{10}$/, message: '手机号格式有误',trigger: 'onBlur' }]"/>

		<van-field readonly clickable v-if="!isDetail" class="select" is-link v-model="relationWithSelfName" prop="relationWithSelf" :disabled="isDetail" required label="与本人关系"  placeholder="请选择与本人关系"  @click="selectValue(relationWithSelfList,'relationWithSelfList')" :rules="[{ required: true, message: '与本人关系不能为空', trigger: 'onChange' }]"/>
		<van-field readonly  required v-else disabled v-model="data.relationWithSelfDescr"  label="与本人关系"/>

		<van-field v-model="data.email" prop="email" required label="个人邮箱" v-if="!isDetail" placeholder="请输入个人邮箱" :rules="[{ required: true, message: '个人邮箱不能为空', trigger: 'onChange' }, { pattern: /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/, message: '邮箱格式有误',trigger: 'onBlur' }]" />
		<van-field v-model="data.entryEmail" label="个人邮箱" v-else :disabled="isDetail" placeholder="请输入个人邮箱"/>

		<van-field readonly clickable v-if="!isDetail" class="select" is-link v-model="politicalStatusName" prop="relationWithSelf" :disabled="isDetail" required label="政治面貌"  placeholder="请选择政治面貌"  @click="selectValue(politicalStatusList,'politicalStatusList')" :rules="[{ required: true, message: '政治面貌不能为空', trigger: 'onChange' }]"/>
		<van-field readonly  required v-else disabled v-model="data.politicalStatusDescr"  label="政治面貌"/>
		
		<van-popup v-model="showPicker"  position="bottom">
			<van-picker
				title="请选择"
				show-toolbar
				value-key="label"
				:columns="columns"
				@confirm="onConfirm"
				@cancel="showPicker = false"/>
		</van-popup>
		<!-- 日历选择 弹层-->
		<van-calendar
			v-model="showCalendar"
			:row-height="45"
			:show-confirm="false"	
			:min-date="birthDateLimit[0]"
			:max-date="birthDateLimit[1]"
			@confirm="onCalendar" />

		<!-- 日历选择 弹层-->
		<van-calendar
			v-model="showDiverCalendar"
			:row-height="45"
			:min-date="dateLimit[0]"
			:max-date="dateLimit[1]"
			:show-confirm="false"	
			@confirm="onDriverCalendar" />

		<!-- 搜索 -->
		<van-popup class="search-wrap" v-model="showSearch"  position="top">
			<form>
				<van-search v-model="queryVal" show-action placeholder="请输入推荐人姓名搜索" @cancel="onCancel" @search="getPersonInfo(queryVal)" />
			</form>
			<van-list v-model="loadingList" :finished="finished">
				<van-cell v-for="item in personList" :key="item.empId" :title="item.name+'/'+item.deptName" @click="confirmVal(item)" />
			</van-list>
		</van-popup>

		<van-overlay :show="fullscreenLoading" z-index="20" />
		<van-loading size="24px" class="full-screen-loading" color="#fff" v-if="fullscreenLoading">身份验证中...</van-loading>
	</div>
</template>

<script>
import Vue from 'vue'
import { Notify } from 'vant'
Vue.use(Notify)

import { getPinyin, getOutsideCheckId, getUsers } from '../network'
import { staticList } from '../network/staticList'


export default {
	name: 'mbaseInfo',
	props: {
		isDetail:{
			type: Boolean,
		},
		data: {
            type: Object,
            required: true,
        },
	},
	data() {
		return {
			showCalendar: false,
			showDiverCalendar: false,
			isCheckId: false,
			firstNameSrchList: [], // 姓拼音选择列表 
			firstNameAcList: [], // 名字拼音列表 
			nationalTypeList: [],
			channelList: [], // 招聘渠道
			nationIdList: [], // 国家
			maritalStatusList:[],//婚姻状态
			personList:[], // 人员列表
			fullscreenLoading: false,
			nationalIdTypeName: '身份证',
			countryName:'中国',
			channelName: '',
			driverLicenseTypeName:'', // 驾照类型名称
			maritalStatus:'', //婚姻状态
			relationWithSelfName:'',
			maritalStatusName:'',
			politicalStatusName:'',
			recomUserName: '',
			columns:[],
			typeVal:'',
			showPicker: false,
			loadingList:false,
			showSearch: false,
			finished: true,
			queryVal:'',
			sexDisablle: false,
			birthDateLimit: [
				new Date(1900, 0, 1),
				new Date(),
			],
			dateLimit:[
				new Date(),
				new Date(new Date().getFullYear()+10,11,31),
			],
		}
	},
	watch: {
		'data.nationalId'(valId){
			if(valId.length === 18 && this.data.nationalIdType === '1A'){
				// 如果身份证是18位，根据倒数第二位判断男女
				valId.substr(16,1)%2 === 0 ? this.data.sex = 'F' : this.data.sex = 'M'
				// 如果身份证是18位，取出出生年月日
				// this.baseInfoForm.birthDate = valId.substr(6,4)+"-"+valId.substr(10,2)+"-"+valId.substr(12,2)
				this.$set(this.data, 'birthDate',  valId.substr(6,4)+"-"+valId.substr(10,2)+"-"+valId.substr(12,2))
				this.sexDisablle = true
			}else{
				this.sexDisablle = false
			}
		},
		'data.country'(val){
			if (val === 'CHN') {
				this.data.nationalIdType = '1A'
				this.nationalIdTypeName = '身份证'
			} else if (val === 'GAT') {
				this.data.nationalIdType = '1P';
				this.nationalIdTypeName = '港澳台来往内地通行证'
			} else {
				this.data.nationalIdType = '1E';
				this.nationalIdTypeName = '护照'
			}
		},
		'data.lastNameAc'(){
			this.data.fullName = this.data.lastNameAc + this.data.firstNameAc
		},
		'data.firstNameAc'(){
			this.data.fullName = this.data.lastNameAc + this.data.firstNameAc
		}
	},
	created() {
		// 静态数据赋值
		this.nationalTypeList = staticList.nationalTypeList
		this.channelList = staticList.channelList
		this.nationIdList = staticList.nationIdList
		this.maritalStatusList = staticList.maritalStatusList
		this.driverLicenseTypeList = staticList.driverLicenseTypeList
		this.relationWithSelfList = staticList.relationWithSelfList
		this.politicalStatusList= staticList.politicalStatusList;
	},
	methods: {
				// 选择日期
		onCalendar(date){
			this.data.birthDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
			this.showCalendar = false
		},
		onDriverCalendar(date){
			this.data.driverLicenseEffectDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
			this.showDiverCalendar = false
		},
		selectValue(list,type){
			if(this.isCheckId && type !=='channelList' && type !== 'relationWithSelfList' && type !=='driverLicenseTypeList' && type !== 'maritalStatusList' && type !== 'politicalStatusList'){
				return
			}
			if(!list.length){
				if(type === 'firstNameSrchList' && this.data.lastNameSrch === ''){
					Notify({ type: 'warning', message:'请先输入姓'})
				}
				if(type === 'firstNameAcList' && this.data.firstNameSrch === ''){
					Notify({ type: 'warning', message:'请先输入名'})
				} 
			} else{
				this.showPicker = true
				this.columns = list 
				this.typeVal = type
			}
		},
		// 取消搜索
		onCancel(){
			this.showSearch = false
			this.personList = []
			this.queryVal = ''
		},
		// 搜索
		selectInfo(){
			this.personList = []
			this.showSearch = true
		},
		// 搜索确认值
		confirmVal(item){
			this.personList = []
			this.queryVal = ''
			this.showSearch = false
			this.recomUserName = item.name
			this.data.recomUser = item.empId
		},
		// picker 确认值
		onConfirm(value){
			/* 姓 */
			if(this.typeVal === 'firstNameSrchList'){
				this.data.lastNameAc = value.value
			}
			/* 名 */
			if(this.typeVal === 'firstNameAcList'){
				this.data.firstNameAc = value.value
			}
			/* 证件类型*/
			if(this.typeVal === 'nationalTypeList'){
				this.data.nationalIdType = value.value
				this.nationalIdTypeName = value.label
				// 判断中国/港澳台
				this.changeType(value.value)
			}
			/* 招聘渠道 */
			if(this.typeVal === 'channelList'){
				this.data.channel = value.value
				this.channelName = value.label
			}
			/* 国家 */
			if(this.typeVal === 'nationIdList'){
				this.data.country= value.value
				this.countryName = value.label
			}

			/* 婚姻状态 */
			if(this.typeVal === 'maritalStatusList'){
				this.data.maritalStatus= value.value
				this.maritalStatusName = value.label
			}
			/* 与本人关系 */
			if(this.typeVal === 'relationWithSelfList'){
				this.data.relationWithSelf= value.value
				this.relationWithSelfName = value.label
			}
			/* 政治面貌 */
			if(this.typeVal ==='politicalStatusList'){
				this.data.politicalStatus= value.value
				this.politicalStatusName = value.label
			}
			/* 驾照类型 */
			if(this.typeVal === 'driverLicenseTypeList'){
				this.data.driverLicenseType= value.value
				this.driverLicenseTypeName = value.label
				if(this.data.driverLicenseType==='10'){
					this.$set(this.data, 'driverLicenseEffectDate', '');
				}
			}
			
			this.showPicker = false
		},
		// 选择推荐人
		getPersonInfo(query){
			if (query !== '') {
				setTimeout(() => {
					this.personList = [];
					let params = {
						pageNum: 1,
						pageSize: 30,
						queryName: query,
					}
					this.finished = false
					return getUsers(params).then((res)=>{
						this.finished = true
						let data =res.data
						if(data.code === 'S00000'){
							this.personList = data.data;
						} else {
							Notify({ type: 'danger', message: data.message })
						}
					}).catch((error)=>{
						this.finished = false
						// this.$message.error(JSON.stringify(error))
					})
				}, 200);
			} else{
				this.personList = []	
			}
		},
		// 根据姓名输入，导入拼音
		searchFirstNameSrch(type){
			// 重置
			if(type === '1'){
				this.data.lastNameAc = ''
			}else{
				this.data.firstNameAc = ''
			}
			let params = { 
				name: type === '1' ? this.data.lastNameSrch : this.data.firstNameSrch
			}
			return getPinyin(params).then((res) => {
				let data = res.data
				if(data.code === 'S00000'){	
					let dataList = []
					if(data.data.length){
						for(let i = 0;i<data.data.length; i++ ){
							let listObj = {
								value: data.data[i],
								label: data.data[i],
							}
							dataList.push(listObj)
						}

						type === '1' ? this.firstNameSrchList = dataList : this.firstNameAcList = dataList
						// 如果只有一条数据，不是多音字，直接赋值
						if(this.firstNameSrchList.length === 1){
							this.data.lastNameAc = this.firstNameSrchList[0].value
						}
						if(this.firstNameAcList.length === 1){
							this.data.firstNameAc = this.firstNameAcList[0].value
						}
					}
					
				}
			}).catch((error)=>{
				// this.$message.error(JSON.stringify(error))
			})
		},
		// 根据国籍的，选择对应的证件类型
		changeNationType(val) {
			// 如果国籍中国
			if (val === 'CHN') {
				this.data.nationalIdType = '1A'
				this.nationalIdTypeName = '身份证'
			} else if (val === 'GAT') {
				this.data.nationalIdType = '1P';
				this.nationalIdTypeName = '港澳台来往内地通行证'
			} else {
				this.data.nationalIdType = '1E';
				this.nationalIdTypeName = '护照'
			}
		},
		// 证件类型校验国籍
		changeType(val) {
			if ((val === '1A' && this.data.country !== 'CHN')
				|| (val === '1P' && this.data.country !== 'GAT')
				|| (val === '1E' && this.data.country === 'CHN')
				|| (val === '1E' && this.data.country === 'GAT')) {
				this.data.country = ''
				this.countryName = ''
			}
		},
		// 身份证验证
		checkIdCard(){
			if(this.data.lastNameSrch === ''){
				Notify({ type: 'warning', message: '请输入姓'})
				return
			}
			if(this.data.firstNameSrch === ''){
				Notify({ type: 'warning', message: '请输入名'})
				return
			}
			if(this.data.nationalId === ''){
				Notify({ type: 'warning', message: '请输入证件号码'})
				return
			}
			if(!this.data.emplType){
				Notify({ type: 'warning', message: '请先选择人员类别'})
				return
			}
			let params = {
				name: this.data.lastNameSrch + this.data.firstNameSrch,
				nationalId: this.data.nationalId,
				nationalIdType: this.data.nationalIdType,
				emplType: this.data.emplType,
			}
			this.fullscreenLoading = true
			return getOutsideCheckId(params).then((res) => {
				this.fullscreenLoading = false
				let data = res.data
				if(data.code === 'S00000'){
					if (data.data) {
						Notify({ type: 'success', message: `身份验证成功，${data.data}` })
					} else {
						Notify({ type: 'success', message: '身份验证成功' })
					}
					this.isCheckId = true
					this.$emit('checkId', true)
				} else {
					Notify({ type: 'danger', message: '身份验证失败，请检查' })
					this.$emit('checkId', false)
					
				}
			}).catch((error)=>{
				this.fullscreenLoading = false
				Notify({ type: 'error', message: error.response.data.message })
				// this.$message.error(JSON.stringify(error))
			})
		},
	},
};
</script>

<style lang="scss">
	.base-info{
		.full-screen-loading{
			z-index:100;
			width: 100%;
			height: 100%;
			position: fixed;
			left: 0;
			top: 0;
			overflow: hidden;
			text-align:center;
			.van-loading__spinner,
			.van-loading__text{
				color: #fff;
				margin-top: 50%;
			}
		}
		
	}
	.moblie-wrapper{
		.no-border-bottom.van-cell{
			&::after{
				border-bottom:none;
			}
		}
		.van-radio__label{
			color: #333;
		}
		.yz{
			padding:0 16px;
			box-sizing: border-box;
			width: 100%; 
			display: inline-block;
			text-align:right;
			position: relative;
			&::after{
				content:'';
				position: absolute;
				z-index: 10;
				left: 16px;
				width: 100%;
				bottom:0;
				border-bottom: 1px solid #f2f2f2;

			}
			.tip{
				color: #C6CBD1;
				font-size: 12px;
				display:block;
				text-align:left;
			}
		}
		.submit-btn{
			padding: 9px 16px;
			box-sizing: border-box;
		}
		.van-button--info{
			display:inline-block;
			width: 100%;
			height: 46px;
			line-height:46px;
			background: #05B555;
			border-color: #05B555;
			border-radius:6px;
		}
		.van-button--small{
			margin: 10px 0 10px;
			color: #C6CBD1;
			border-color: #e5e5e5;
			white-space: nowrap;
			cursor: pointer;
			background: #fff;
			border: 1px solid #dcdfe6;
		}
		.van-icon-search::before{
			vertical-align:-4px;
		}
		.van-icon-arrow::before{
			vertical-align: -4px;
			color: #C6CBD1;
			font-size: 14px;
		}
		
	}
</style>
